import React from 'react';
import { Paper } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { getAreaAsHectares } from '@/utils/stringutils';
import { StyledTableCell, StyledTableRow } from './styledComponent';

export default function ParcelleTable({ parcelles }) {
  const rows = parcelles
    .map((olFeat) => ({
      commune: `${olFeat.get('commune_nom')} (${olFeat.get('commune')})`,
      prefixe: olFeat.get('prefixe'),
      section: olFeat.get('section'),
      numero: olFeat.get('numero'),
      contenance: getAreaAsHectares(olFeat.get('contenance')),
    }))
    .sort(
      (a, b) =>
        a.commune.localeCompare(b.commune, 'fr') ||
        a.prefixe.localeCompare(b.prefixe, 'fr', { numeric: true }) ||
        a.section.localeCompare(b.section, 'fr') ||
        a.numero.localeCompare(b.numero, 'fr', { numeric: true }),
    );

  return (
    <TableContainer component={Paper} elevation={2} sx={{ mt: 2 }}>
      <Table aria-label="constraints-table" size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">Commune</StyledTableCell>
            <StyledTableCell align="left">Préfixe</StyledTableCell>
            <StyledTableCell align="left">Section</StyledTableCell>
            <StyledTableCell align="left">Numéro</StyledTableCell>
            <StyledTableCell align="left">Surface</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <StyledTableRow key={idx}>
              <StyledTableCell align="left">{row.commune}</StyledTableCell>
              <StyledTableCell align="left">{row.prefixe}</StyledTableCell>
              <StyledTableCell align="left">{row.section}</StyledTableCell>
              <StyledTableCell align="left">{row.numero}</StyledTableCell>
              <StyledTableCell align="left">{row.contenance}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ParcelleTable.propTypes = {
  parcelles: PropTypes.arrayOf(PropTypes.object).isRequired,
};
